export default __webpack_public_path__ + "5f75273538fdf79b98812f950b918c79.svg";